<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>
      新規登録
    </h2>
    <management-form />
  </v-container>
</template>
<script>
import ManagementForm from './_Form'

/**
 * マニフェスト新規登録
 */
export default {
  name: 'DriverManifestManagementNew',
  components: {
    ManagementForm
  },
  mixins: [],
  data() {
    return {
      breadcrumbs: [
        { text: 'マニフェスト一覧', disabled: false, to: '/driver/manifest/managements', exact: true },
        { text: '新規登録', disabled: true, to: '' },
      ]
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
}
</script>
